<div
  class="xux-dropdown btn-group xux-switcher"
  [ngClass]="params.containerClass"
  data-e2e-id="xux-switcher"
  *ngIf="!hidden"
>
  <button
    type="button"
    class="btn btn-default btn-site-name"
    data-toggle="dropdown"
    [disabled]="isDisabled$ | async"
  >
    {{ staticTextContent.SwitchSite | translate }}
  </button>

  <button
    type="button"
    class="btn btn-default dropdown-toggle"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
    [disabled]="isDisabled$ | async"
  >
    <i class="glyphicon glyphicon-menu-down"></i>
    <span class="sr-only">{{
      staticTextContent.toggleDropdown | translate
    }}</span>
  </button>

  <div class="dropdown-menu">
    <div class="dropdown-menu-item search-box" data-e2e-id="search-box-button" (click)="clickSearchBox($event)">
      <div class="search-icon">
        <i class="xicon-search"></i>
      </div>
      <input
        #searchElement
        type="search"
        class="xux-switcher-filter"
        [placeholder]="placeholder"
        [formControl]="searchControl"
        (ngModelChange)="onFilter($event)"
      />
    </div>
      <ul class="dropdown-menu-list" data-e2e-id="dropdown-menu-list">
        <li *ngFor="let option of selectOptions$ | async" class="dropdown-menu-item" [class.selected]="option.selected">
        <a (click)="selectOption(option.value)">{{ option.text | translate }}</a>
      </li>
      <li *ngIf="isDataSourceEmpty$ | async" class="dropdown-menu-item" style="pointer-events: none;">
        <a>{{ staticTextContent.NoMatches | translate }}</a>
      </li>
    </ul>
      <div class="dropdown-menu-item add-new"  [ngClass]="{'disabled': isAddButtonDisabled}" data-e2e-id="add-new-item-button">
      <a (click)="addNewItem()">{{ addItemCaption | translate }}</a>
    </div>
  </div>
</div>
